import { Table, Typography } from "antd";
import { SelectHorariosItem } from "./Items";
const { Text } = Typography;

function TurnoGrid({ turno, horariosCatalogo, onCellChange, empresaId, headersToken }) {
    // fila base
    const rows = Array.from({ length: turno.ciclos }, (_, i) => ({ row: i + 1, key: i + 1 }));

    // index rápido para encontrar la celda
    const cellMap = new Map(turno.grid.map(x => [`${x.r}:${x.c}`, x.horarios.map(String)]));

    const COL_WIDTH = 200;   // ancho fijo de cada celda
    const CICLO_WIDTH = 90;  // ancho fijo primera columna

    const columns = [
        {
            title: "Ciclo",
            dataIndex: "row",
            width: CICLO_WIDTH,
            fixed: "left",  // 👈 opcional si quieres que se quede fija
            render: (v) => <Text>{v}</Text>
        },
        ...turno.columnas.map(col => ({
            title: col.label,
            dataIndex: col.key,
            width: COL_WIDTH,   // 👈 IMPORTANTE
            render: (_, record) => {
                const r = record.row;
                const c = col.key;
                const value = cellMap.get(`${r}:${c}`) || [];

                return (
                    <SelectHorariosItem
                        mode="multiple"
                        placeholder="Horarios"
                        lessCharge
                        value={value}
                        style={{ width: "100%" }}
                        empresaId={empresaId}
                        headersToken={headersToken}
                        onChange={(ids) => onCellChange({ r, c, horarios: ids })}
                    />
                );
            }
        }))
    ];

    const totalWidth = CICLO_WIDTH + (turno.columnas.length * COL_WIDTH);

    return (
        <Table
            columns={columns}
            dataSource={rows}
            pagination={false}
            size="small"
            tableLayout="fixed"   // 👈 CRÍTICO
            scroll={{ x: totalWidth }}
        />
    );
}

export default TurnoGrid;